import { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";

/** Why an "Add to Tracker" dialog has nothing to send. */
export type TrackerAddRefusal = "pickTracker" | "selectLead";

/**
 * The line an "Add to Tracker" dialog shows when Add has nothing to send (PREC-4497).
 *
 * Both dialogs (the Messages footer's and the list table's) used to return nothing on a missing
 * tracker or an empty selection, which their callers read as a successful add: the dialog closed,
 * or stayed open, without a word. `refuse` names the reason and answers `false`, so a handler can
 * `return refuse("pickTracker")` and its caller keeps the dialog open. `clear` goes on a pick and on
 * close, so the line never outlives the problem it names.
 */
export const useTrackerAddHint = () => {
	const { t } = useTranslation();
	const [hint, setHint] = useState<string | null>(null);

	const refuse = useCallback(
		(reason: TrackerAddRefusal): false => {
			setHint(t(`inbox.trackerFooter.${reason}`));

			return false;
		},
		[t]
	);

	const clear = useCallback(() => setHint(null), []);

	return { hint, refuse, clear };
};
